

























import {
  Board
  pos_from_xy
  pos_to_str
  pos_from_str
  pos_array_from_str
  BLACK
  WHITE
} from '@oth/board'
import Disc from './Disc'
import Player from '../player.worker'
import i18n from '../i18n'
import sound from '../sound'

worker = new Player

export default
  props: ['user', 'level', 'guide', 'entered_moves']

  data: -> {
    board: new Board
    turn: BLACK
    flips: []
    hover_at: null
    undo_stack: []
    thinking: false
    user_moves: 0
    gameover: false
    will_flip_enabled: false
    keys: []
    is_touch: false
    BLACK
    i18n
  }

  mounted: ->
    worker.postMessage type:'set_level', level:@level
    @proceed()
    gtag 'event', 'start',
      event_category: 'game'
      event_label: @level

    @key_listener = (e) => @keypress(e)
    window.addEventListener 'keypress', @key_listener

  beforeDestroy: ->
    window.removeEventListener 'keypress', @key_listener

  updated: -> @$el.classList.add 'animate'

  computed:
    can_undo: -> not @thinking and @user_moves and not @gameover

    rows: ->
      rows = for y in [0...8]
        row = []
        [0...8].forEach (x) =>
          pos = pos_from_xy x, y
          disc = @board.get(pos)

          row.push
            pos: pos
            disc:
              if disc == BLACK
                'black'
              else if disc == WHITE
                'white'
              else
                null
            can_move:
              if @turn == @user
                @board.can_move(@turn, pos)
              else
                false
            is_hover:
              if @turn == @user
                @hover_at == pos and @board.can_move(@turn, pos)
              else
                false
            will_flip: @will_flip_enabled and @flips.indexOf(pos) >= 0
            move: =>
              if @turn == @user
                @move pos
            enter: =>
              if @turn == @user and not @is_touch
                @flips = @board.move(@turn, pos)
                if @flips.length
                  @board.undo @turn, pos, @flips
                  @hover_at = pos
                @will_flip_enabled = false
            leave: =>
              @hover_at = null
              @flips = []
              @will_flip_enabled = false
        row

      setTimeout (=> @will_flip_enabled = true), 50 # XXX

      rows

  methods:
    message: (args) -> @$emit 'message', args

    move: (pos, move_only=false) ->
      @flips = []
      @hover_at = null
      flips = @board.move @turn, pos
      return false unless flips.length
      sound 'move' unless move_only
      @$emit 'add-move', pos_to_str(pos, @turn)
      @undo_stack.push [@turn, pos, flips]
      if @turn == @user
        @user_moves++
      @turn = -@turn
      unless move_only
        @proceed()
      true

    proceed: ->
      if @board.any_moves @turn
        if @turn == @user
          @message text:  @i18n.t.your_turn
        else
          @worker_move()
      else
        @turn = -@turn
        if @board.any_moves(@turn)
          if @turn == @user
            @message text: @i18n.t.i_pass
          else
            @message text: @i18n.t.you_pass, pass: => @worker_move()
        else
          @gameover = true
          outcome = @board.outcome(@user)
          discs = "#{@board.count(@user)}:#{@board.count(-@user)}"
          if outcome > 0
            @message text: i18n.expand('win', {discs}), back: => @$emit 'back'
            gtag 'event', 'win',
              event_category: 'game'
              event_label: @level
              value: outcome
          else if outcome < 0
            @message
              text: i18n.expand('lose', {discs}), back: => @$emit 'back'
            gtag 'event', 'lose',
              event_category: 'game'
              event_label: @level
              value: outcome
          else
            @message text: @i18n.t.draw, back: => @$emit 'back'
            gtag 'event', 'draw',
              event_category: 'game'
              event_label: @level
              value: outcome

    worker_move: ->
      @message text: @i18n.t.thinking, spin: true
      t = Date.now()
      worker.onmessage = (e) =>
        worker.onmessage = null
        t = Date.now() - t
        console.log "#{t} msec"

        {move, value} = e.data
        setTimeout (=>
          @move move
          @thinking = false
        ), if t < 2000 then 2000 - t else 0
      @thinking = true
      worker.postMessage type:'move', board:@board.dump(), turn:@turn

    undo: ->
      throw new Error 'cannot undo' unless @can_undo
      loop
        [turn, pos, flips] = @undo_stack.pop()
        @board.undo turn, pos, flips
        @$emit 'undo'
        break if turn == @user
      @user_moves--
      if @turn != @user
        @turn = @user
        @message text:  @i18n.t.your_turn

      sound 'undo'

      # BLACK MAGIC TO LET VUE UPDATE
      @board.board.push(0)
      @board.board.pop()

    keypress: (e) ->
      return if e.target.nodeName == 'INPUT'

      if e.key == 'u'
        if @can_undo
          @undo()
        else
          sound 'alert'
        return

      @keys.push(e.key)
      @keys = @keys.slice(-2)
      str = @keys.join('')
      try
        move = pos_from_str(str)
      catch
        move = 0

      if move
        if @turn==@user and @board.can_move(@user, move)
          @move move
        else
          sound 'alert'

  watch:
    can_undo: -> @$emit 'set-undo-btn', enabled: @can_undo, undo: @undo

    entered_moves: ->
      @undo_stack = []
      @user_moves = 0
      @$emit 'reset-moves'
      @board = new Board
      success = true
      @turn = BLACK
      @gameover = false

      for move in pos_array_from_str(@entered_moves)
        unless @move move, true
          success = false
          break
        @turn = -@turn unless @board.any_moves(@turn)

      if success
        @proceed()
      else
        @message text: @i18n.t.invalid_moves, error: true
        sound 'alert'
        setTimeout (=> @proceed()), 2000

  components: { Disc }
